const mediaItems = [
  {
    title: '《长安十二时辰》名场面回顾',
    desc: '雷佳音饰演的张小敬在长安城中的高燃打斗场面，一气呵成的长镜头展现盛唐气象。',
    duration: '05:32',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20action%20drama%20scene%20with%20ancient%20city%20setting%2C%20warrior%20in%20armor%2C%20dramatic%20battle%20scene%2C%20warm%20torch%20light%2C%20cinematic%20epic%20shot%2C%20Tang%20dynasty%20aesthetic%2C%20high%20quality&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    title: '《繁花》沪上风情特辑',
    desc: '走进王家卫镜头下的九十年代上海，黄河路的霓虹灯与弄堂里的烟火人间。',
    duration: '08:15',
    img: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20night%20scene%20with%20neon%20signs%20and%20busy%20streets%2C%20vintage%20Chinese%20city%20atmosphere%2C%20warm%20glowing%20lights%2C%20nostalgic%20cinematic%20style%2C%20Wong%20Kar%20wai%20aesthetic%2C%20high%20quality&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    title: '《三体》科幻视觉解析',
    desc: '深度拆解三体世界的视觉呈现，从古筝行动到三体游戏，每一帧都是视觉盛宴。',
    duration: '12:48',
    img: 'https://readdy.ai/api/search-image?query=Sci%20fi%20visual%20effects%20showcase%20with%20cosmic%20scenes%2C%20futuristic%20technology%20and%20space%20elements%2C%20dark%20blue%20and%20silver%20aesthetic%2C%20three%20body%20problem%20inspired%20visuals%2C%20cinematic%20quality%2C%20high%20tech%20atmosphere&width=640&height=360&seq=media-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精彩花絮</h2>
          <p className="mt-2 text-sm text-foreground-500">幕后故事与剧集深度解析</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/50 transition-colors"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  title={`${item.title} - 窝窝影院`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl text-accent-600 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}